Views.add(new class extends AbstractView {

  constructor() {
    super({
      name: 'ai-warning',
      overlay: true
    });
  }

  onActive() {

  }

  mainTitle() {
    return this.app._ai_warning_title || "Avertissement";
  }

  smallTitle() {
    return this.app._ai_warning_text || 'Avertissement sur l\'utilisation du chatbot IA';
  }

  initEventListeners() {

  }

  _htmlBase() {
    const pageContent = this.app._ai_warning_page_content || `
        <p class="slaask-widget-homepage-card-title">
          Avertissement – Chatbot IA
        </p>
        <p>
          Ce service utilise une intelligence artificielle pour générer des réponses à partir de documents sources. Malgré nos efforts, les informations fournies peuvent être inexactes, incomplètes ou incorrectes et ne constituent pas un conseil professionnel.
        </p>
        <p>
          Il est recommandé de vérifier les informations importantes auprès de sources officielles et de ne pas fonder de décisions critiques uniquement sur les réponses du chatbot.
        </p>
        <p>
          Les échanges peuvent être conservés à des fins d'amélioration du service. Merci de ne pas partager de données sensibles ou personnelles.
        </p>
        <p>
          L'utilisation de ce service implique l'acceptation de ces limites et exclut toute responsabilité quant aux décisions prises sur la base des réponses fournies.
        </p>
        <a target="_blank" href="${this.app._whitelabel_link}" class="slaask-widget-homepage-cta" style="background-color: ${this.app._window_color};color: #ffffff; gap: 10px;">
          En savoir plus sur notre politique sur l'IA
          ${Svg.getIcon('externalLink', { size: '12px', height: '12px' })}
        </a>
    `;
    
    return `
      <div class="slaask-widget-homepage-card slaask-widget-card">
        ${pageContent}
      </div>`
  }

});
